import { useTracking, withContextualizedTracking } from 'lib/analytics'
import { Reservation } from 'src/types/reservation'
import { RegItem } from 'src/types/regItem'
import DeleteContributionModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/DeleteContributionModal/DeleteContributionModal'
import DeleteFavorModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/DeleteFavorModal/DeleteFavorModal'
import UnmarkRegItemPurchaseModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkRegItemPurchaseModal/UnmarkRegItemPurchaseModal'

interface UseGetUnmarkModalProps {
  reservation: Reservation
  trackingOverrides?: Record<string, unknown>
}

const getUnmarkPurchaseModal = (regItem: RegItem) => {
  if (regItem.isCrowdfund) {
    return DeleteContributionModal
  }

  if (regItem.isFavor) {
    return DeleteFavorModal
  }

  return UnmarkRegItemPurchaseModal
}

/*
 * When we launch the unmark as purchased warning modal, we want
 * to ensure that we pass necessary tracking context (e.g. the
 * event location) so that the events that are triggered from
 * the modal get the appropriate context without prop drilling.
 */
const useTrackedUnmarkModal = ({
  reservation,
  trackingOverrides = {},
}: UseGetUnmarkModalProps) => {
  const tracker = useTracking()

  return withContextualizedTracking({
    ...tracker.getTrackingData(),
    ...trackingOverrides,
  })(getUnmarkPurchaseModal(reservation.regItem))
}

export default useTrackedUnmarkModal
